<opac-dialog size="small" [open]="isStatsModalOpen()" [title]="'history.stats.title' | translate" (closed)="close()">
  <app-user-history-stats-dialog-skeleton *ngIf="isLoading()"></app-user-history-stats-dialog-skeleton>

  <ng-container *ngIf="historyItemStats()">
    <app-user-history-stats-dialog-item
      [label]="icon().label | translate"
      [value]="historyItemStats().title"
    >
      <div class="main-icon">
        <opac-icon [icon]="icon().icon"></opac-icon>
      </div>
    </app-user-history-stats-dialog-item>

    <div class="statistics">
      <app-user-history-stats-dialog-item
        *ngIf="historyItemStats().loanStart as loanStart"
        [label]="'history.checkout.start' | translate"
        [value]="loanStart | date"
      >
        <opac-icon icon="first_access"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="historyItemStats().loanEnd as loanEnd"
        [label]="'history.checkout.end' | translate"
        [value]="loanEnd | date"
      >
        <opac-icon icon="return_date"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="historyItemStats().ebookTimeReading as timeReading"
        [label]="'history.checkout.consumptiontime' | translate"
        [value]="timeReading | duration"
      >
        <opac-icon icon="clock"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="selectedHistoryItem().percentage > 0 && historyItemStats().stats.pagesPerHour as pagesPerHour"
        [label]="'stats.pagesHour' | translate"
        [value]="pagesPerHour | number: '1.0-2'"
      >
        <opac-icon icon="speed"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="selectedHistoryItem().percentage > 0 && historyItemStats().stats.pagesRead as pagesRead"
        [label]="'stats.readPages' | translate"
        [value]="pagesRead | number: '1.0-0'"
      >
        <opac-icon icon="format_02_book"></opac-icon>
      </app-user-history-stats-dialog-item>
    </div>
  </ng-container>
</opac-dialog>
